module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Glossary of Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Bunádh [pronounced boon-ad]—Gaelic for “origin.” The fictional home of the Eye of Scota on the planet Dalriata.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Ch—ch is always pronounced as in “loch.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Cináed [pronounced kin-a-ed] MacAlpin—Based on the character of Cináed mac Ailpín (modern Gaelic: Coinneach mac Ailpein), commonly Anglicized as Kenneth MacAlpin or MacAlpine, and known in most modern regnal lists as Kenneth I (died February 13, 858), was king of the Picts. According to national myth, first king of Scots, earning him the posthumous nickname of An Ferbasach [pronounced fer-basach], “The Conqueror.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Crìosdaidh [pronounced kry-us-dayd]—Gaelic for “Christian.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Dálriata [dal-ryada]/Dál Riata (also Dalriada or Dalriata)—A Gaelic overkingdom on the western coast of Scotland with some territory on the northern coast of Ireland. In the late sixth and early seventh centuries, it encompassed roughly what is now Argyll and Bute and Lochaber in Scotland and also County Antrim in Northern Ireland. Also: a fictional planet in the Canis Major Dwarf Galaxy, 25,000 light-years from Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("darach [pronounced darach]—Gaelic for “oak.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Dia [pronounced dee-ah]—Gaelic for “God.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Eye of Scota—A fictional gateway between Earth and the planet Dalriata.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Scota [pronounced scoh-ta]—In Irish mythology, Scottish mythology, and pseudohistory, the name given to two different mythological daughters of two different Egyptian pharaohs, to whom the Gaels traced their ancestry, allegedly explaining the name Scoti, applied by the Romans to Irish raiders, and later to the Irish invaders of Argyll and Caledonia, which became known as Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("slànach [pronounced sla-nach]—Gaelic for “healing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("sùbh [pronounced suth; "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("u")]), _vm._v(" as in “foot”]—Gaelic for “berry.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0